import { HelpAssistTicketInfoAppointmentScheduleDto } from "mock-api/src/shared-v2-types";
import { Site } from "src/app/core/sites";
import { getApiDetailsDecorator } from "src/utils";
import { HelpAssistTicketAppointment } from "../help-assist-ticket-appointment.model";
import { PartnerHelpAssistTicketAppointmentDraft } from "../ticket-appointment-draft/help-assist-ticket-appointment-draft.model";

const api =
  getApiDetailsDecorator<HelpAssistTicketInfoAppointmentScheduleDto>();

export class PartnerHelpAssistTicketSchedule {
  private constructor(args: ClassProperties<PartnerHelpAssistTicketSchedule>) {
    this.appointment = args.appointment;
    this.isAppointmentApprovalRequired = args.isAppointmentApprovalRequired;
    this.isAppointmentOwnerApprovalRequired =
      args.isAppointmentOwnerApprovalRequired;
    this.ticketAppointment = args.ticketAppointment;
  }

  @api({
    key: "appointment",
    uiModel: HelpAssistTicketAppointment,
  })
  public readonly appointment: HelpAssistTicketAppointment | null;
  @api({ key: "appointmentApprovalRequired" })
  public readonly isAppointmentApprovalRequired: boolean;
  @api({ key: "appointmentOwnerApprovalRequired" })
  public readonly isAppointmentOwnerApprovalRequired: boolean;
  @api({
    key: "ticketAppointment",
    uiModel: PartnerHelpAssistTicketAppointmentDraft,
  })
  public readonly ticketAppointment: PartnerHelpAssistTicketAppointmentDraft | null;

  public static deserialize(
    apiModel: HelpAssistTicketInfoAppointmentScheduleDto,
    { site }: TicketDetailsDeserializeArguments,
  ): PartnerHelpAssistTicketSchedule {
    return new PartnerHelpAssistTicketSchedule({
      appointment: apiModel.appointment
        ? HelpAssistTicketAppointment.deserialize(apiModel.appointment, {
            site,
          })
        : null,
      isAppointmentApprovalRequired: apiModel.appointmentApprovalRequired,
      isAppointmentOwnerApprovalRequired:
        apiModel.appointmentOwnerApprovalRequired,
      ticketAppointment: apiModel.ticketAppointment
        ? PartnerHelpAssistTicketAppointmentDraft.deserialize(
            apiModel.ticketAppointment,
            { site },
          )
        : null,
    });
  }
}

export type HelpAssistTicketSchedule = PartnerHelpAssistTicketSchedule;

interface TicketDetailsDeserializeArguments {
  readonly site: Site;
}
